import { type Stats, createStats } from '../domain/stats.js';
import type { ActionEffects } from '../domain/action.js';

export function applyEffects(stats: Stats, effects: ActionEffects): Stats {
  return createStats({
    money: stats.money + (effects.money ?? 0),
    energy: stats.energy + (effects.energy ?? 0),
    happiness: stats.happiness + (effects.happiness ?? 0),
    hunger: stats.hunger + (effects.hunger ?? 0),
    education: stats.education + (effects.education ?? 0),
    foodAtHome: stats.foodAtHome + (effects.foodAtHome ?? 0),
  });
}
